import { status } from './status';

export class AdType {
  typeSettings: any = {
    building: {
      amenities: true,
      unitAmenities: true,
      recreationArea: true,
      location: true,
      title: 'Empreendimentos',
      titlePlaceholder: 'Título do empreendimento',
      titleUnitAmenities: 'Características das unidades',
      titleUnitAmenitiesText: 'Detalhes das unidades',
      incorporation: true,
      multipleUnits: true,
      blockName: 'Bloco',
      blockFloors: true,
      blcokUnitsByFloors: true,
      fields: {
        constructArea: true,
        privateArea: true,
        totalArea: true,
        suite: true,
        room: true,
        bathroom: true,
        garage: true,
        floor: true,
        garageMax: true
      }
    },
    allotment: {
      amenities: true,
      unitAmenities: true,
      recreationArea: true,
      location: true,
      title: 'Loteamento',
      titlePlaceholder: 'Título do loteamento',
      titleUnitAmenities: 'Características das unidades',
      titleUnitAmenitiesText: 'Detalhes das unidades',
      incorporation: true,
      multipleUnits: true,
      unitsStretch: true,
      blockName: 'Quadra / Rua',
      fields: {
        constructArea: true,
        privateArea: true,
        totalArea: true,
        suite: false,
        room: false,
        bathroom: false,
        garage: false,
        floor: false
      }

    },
    properties: {
      amenities: true,
      unitAmenities: true,
      recreationArea: true,
      location: true,
      title: 'Imóveis',
      titlePlaceholder: 'Título (Imóvel em ótima localização...)',
      titleUnitAmenities: 'Características do imóvel',
      titleUnitAmenitiesText: 'Detalhes do imóvel',
      incorporation: true,
      fields: {
        constructArea: true,
        privateArea: true,
        totalArea: true,
        suite: true,
        room: true,
        bathroom: true,
        garage: true,
        floor: true
      }
    },
    ground: {
      amenities: false,
      unitAmenities: true,
      recreationArea: false,
      location: true,
      title: 'Terreno / Lote',
      titlePlaceholder: 'Título (Terreno em ótima localização...)',
      titleUnitAmenities: 'Características do terreno',
      titleUnitAmenitiesText: 'Detalhes do terreno',
      incorporation: true,
      fields: {
        privateArea: true,
        totalArea: true
      }
    },
    vehicles: {
      location: true,
      unitAmenities: true,
      title: 'Veículos',
      titlePlaceholder: 'Título (exemplo BMW X5 2018 - Branco...)',
      titleUnitAmenities: 'Características do veículo',
      titleUnitAmenitiesText: 'Detalhes do veículo',
      fields: {
        km: true,
        year: true,
        brand: true,
        model: true,
        color: true
      }

    }
  };

  getType(type) {
    return this.typeSettings[type] || [];
  }
}

export class Ad {

  //type_id : AdType | string = '';

  ad_category_id: number = null;

  ad_id: number = null;

  update: string = null;

  owner_person_id: any = null;

  title: string = '';

  status: status | string = '';

  data: any = {};

  notify: boolean = false;

  restricted: boolean = false;

  restrictedProposal: boolean = false;

  incorporation: string = '';

  exclusive: boolean = false;

  exclusive_start: Date = null;

  exclusive_end: Date = null;

  correction_auto: number = 0;

  correction_index: number = 0;

  correction_index_date: Date = null;

  correction_rounding: number = 0;

  allow_authorization_requests: any = '1';

  allow_material_requests: any = '1';

  allow_training_requests: any = '1';

  allow_proposal_requests: any = '1';

  available_for_website: any = '1';

  //creator_person_id : number = null;

  //creation : Date = null;

  //last_update : Date = null;

  //publication : Date = null;

}

export class DefaultPromise {

  dp: Promise<any[]> = null;

  constructor(private data: any) {
    this.dp = data;
  }
  getData(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      resolve(this.dp);
    });;
  }

}